// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__DQorR","animloader":"loader_animloader__CLCiH"};